import { render, staticRenderFns } from "./NotaryProduct.handler.vue?vue&type=template&id=fd78816a&"
import script from "./NotaryProduct.handler.vue?vue&type=script&lang=ts&"
export * from "./NotaryProduct.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports